module.exports = __webpack_public_path__ + "img/bac.794ccae9.svg";